import PropTypes from 'prop-types';
import { Tooltip, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

InfoIconButton.propTypes = {
  onClick: PropTypes.func,
  tooltipText: PropTypes.string,
  disableRipple: PropTypes.bool
};

export default function InfoIconButton({ onClick, tooltipText = "Info", disableRipple = false }) {
  return (
    <Tooltip title={tooltipText} arrow>
      <IconButton edge="end" color="secondary" onClick={onClick} disableRipple={disableRipple} sx={disableRipple ? { p: 0, mr: 0.5 } : { mr: 0.5 }}>
        <InfoIcon />
      </IconButton>
    </Tooltip>
  );
}
